import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GeneralFunctionsService } from 'src/app/services/general-functions.service';

@Component({
  selector: 'app-image-selector',
  templateUrl: './image-selector.component.html',
  styleUrls: ['./image-selector.component.css']
})
export class ImageSelectorComponent {
  @Input() imageData: string;
  @Input() placeholderText: string;
  @Input() errorImage: string;

  file: File;
  fileReader: FileReader;

  @Output() enableUpload: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() sendFile: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private generalFunctionsService: GeneralFunctionsService,
    private translate: TranslateService
  ) { }

  handleInputChange(e: any): void {
    this.file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    this.checkFile();
  }

  handleReaderLoaded(e: any): void {
    let reader = e.target;
    this.imageData = reader.result;

    this.enableUpload.emit(true);
  }

  checkFile(): void{
    if(this.file){
      let pattern = /image-*/;
      if (!this.file.type.match(pattern)) {
        this.generalFunctionsService.showWarning(this.translate.instant('common.fileInvalid'));
        return;
      }

      if(this.file.size > 1024 * 768){
        this.generalFunctionsService.showWarning(this.translate.instant('common.fileTooBig'));
        this.file = null;
        return;
      }

      this.fileReader = new FileReader();
      this.fileReader.onload = this.handleReaderLoaded.bind(this);
      this.fileReader.readAsDataURL(this.file);
    } else {
      this.imageData = "";
      this.enableUpload.emit(false);
    }
    this.sendFile.emit({file: this.file, imageData: this.imageData});
  }

  onFilesChange(file: File): void{
    this.file = file;
    this.checkFile();
  }

  onFileInvalids(error: string): void{
    this.generalFunctionsService.showWarning(error);
  }

  imageNotFound(){
    if(this.errorImage) this.imageData = this.errorImage;
    else this.imageData = "/assets/img/image_not_found.jpg";
  }
}
